import React, { useEffect, useState } from 'react';
import {
  Box,
  CircularProgress,
  Grid,
  Paper,
  Typography
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getUserRoles, setUserPermissions } from '../../../../store/user-permissions/actions';
import { serviceLocalStorage } from '../../../../utils/serviceLocalStorage';
import { PermissionsTree } from '../../../company/components/PermissionsTree';

export const UserPermissions = () => {
  const dispatch = useDispatch();
  const { userPermissionsAndRoles, fetchingList, fetchingItem } = useSelector((state) => state.userPermissions);
  const { permissions, roles } = userPermissionsAndRoles;
  const [fetchingItemObject, setFetchingItemObject] = useState({});

  useEffect(() => {
    if (serviceLocalStorage.getUserID()) {
      dispatch(getUserRoles());
    } // eslint-disable-next-line
  }, [
  ]);

  const handleSwitcher = (roleId, permissionId, status) => {
    setFetchingItemObject({ roleId, permissionId });
    const payload = { permission_id: permissionId, status };
    dispatch(setUserPermissions(roleId, payload));
  };

  const userPermissionsColumns = [
    {
      id: 'empty',
      label: '',
    }
  ];

  roles?.forEach((role) => {
    userPermissionsColumns.push({
      id: role.id,
      label: role.name,
      sx: { width: 145 }
    });
  });

  return (
    <Box id="setting">
      <Typography mb="24px" variant="h1" sx={{ color: 'text.primary' }} component="h1">
        Настройка прав пользователей
      </Typography>

      <Paper sx={{ padding: '24px 0 24px' }}>
        <Grid container display="flex" justifyContent='flex-end'>
          {[...userPermissionsColumns].map((headCell) => (
            <Grid
              item
              align="center"
              key={headCell.id}
              color="text.secondary"
              sx={{ ...headCell.sx, fontWeight: 'normal', fontSize: '14px' }}
            >
              {headCell.label}
            </Grid>
          ))}
        </Grid>
      </Paper>

      <Box mt="24px">
        {fetchingList ? (
          <Box display="flex" alignItems="center" justifyContent="center" height='44px'>
            <CircularProgress data-testid="CircularProgress" />
          </Box>
        ) : (
          <PermissionsTree
            permissions={permissions}
            columns={userPermissionsColumns}
            fetching={fetchingItem}
            fetchingItem={fetchingItemObject}
            handleSwitcher={handleSwitcher}
          />
        )}
      </Box>
    </Box>
  );
};
